<template>
 <div id="CouponGrantList">
   <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <el-form :model="listRequestData" label-width="80px" :inline="true" class="demo-form-inline form">
      <el-form-item label="联系电话" prop="userPhone">
        <el-input class="eb-input" v-model="listRequestData.userPhone" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名" prop="trueName">
        <el-input class="eb-input" v-model="listRequestData.trueName" placeholder="真实姓名"></el-input>
      </el-form-item>
      <el-form-item label="机构名称" prop="showName">
        <el-input class="eb-input" v-model="listRequestData.orgName" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item label="角色名称" prop="roleId">
        <el-select class="select" v-model="listRequestData.roleId" placeholder="请选择">
          <el-option v-for="item in userRoleArr" :key="item.id" :label="item.text" :value="listRequestData.roleId==item.id?listRequestData.roleId:item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="button-group">
        <el-button class="eb-button-group-btn eb-button-orange button" @click="submitForm">搜索</el-button>
        <el-button class="eb-button-group-btn eb-button-orange button" @click="resetForm">重置</el-button>
        <el-button class="eb-button-group-btn eb-button-orange button" :disabled="isCouponGrantDisabled" @click="chooseUserClick">发放优惠券</el-button>
    </div>
    <div class="table eb-table">
      <el-table :data.sync="pageData" tooltip-effect="dark" style="width: 100%" @sort-change="sortChange" :stripe="true" ref="listCouponUserRef" row-key="userId" @selection-change="listUserHandleSelectionChange">
        <el-table-column type="selection" width="50" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop='showName' label="用户名" width="90" sortable="custom"></el-table-column>
        <el-table-column prop='trueName' label="真实姓名" width="100" sortable="custom">
          <template slot-scope="scope">
            <a @click="showUserInfo(scope.row)" href="javascript:void(0)" class="a-font-red">{{scope.row.trueName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop='userPhone' label="联系电话" width="110" sortable="custom"></el-table-column>
        <el-table-column prop='userEmail' label="邮箱" sortable="custom" min-width="100"></el-table-column>
        <el-table-column prop='phone' label="工作电话" sortable="custom" width="110"></el-table-column>
        <el-table-column prop='roleNames' label="角色名称" min-width="100" sortable="custom"></el-table-column>
        <el-table-column prop='status' label="状态" width="100" sortable="custom">
          <template slot-scope="scope">
            {{userStatus(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column prop='addTime' label="创建时间" sortable="custom" min-width="110">
          <template slot-scope="scope">
            {{addTime(scope.row.addTime)}}
          </template>
        </el-table-column>
        <el-table-column prop='departName' label="部门名称" sortable="custom" min-width="120"></el-table-column>
        <el-table-column prop='orgName' label="机构名称" sortable="custom" min-width="120"></el-table-column>
      </el-table>
      <eb-pagination :current-page.sync="listRequestData.start" v-if="recordsTotal" @current-change="paginationData" :total="recordsTotal" />
    </div>
    <AddCouponDialog @addCouponClose="onCloseDialog" :isVisible.sync="dialogVisible" :couponInfo="couponInfo" />
 </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { USER_ROLE_GROUP, getUserCouponList } from '@/services/user/user-service';
import { clone } from 'lodash';
import eventBus from '@/plugins/event-bus';
import AddCouponDialog from '@/components/coupon/AddCouponDialog';
export default {
  name: 'CouponGrantList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPagination,
    AddCouponDialog
  },
  data() {
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      userRoleArr: [],
      userStatusArr: [],
      listRequestData: {
        start: 1,
        length: 10,
        orderProp: 'userId',
        orderType: 'asc',
        userPhone: '',
        trueName: '',
        orgName: '',
        roleId: ''
      },
      initParams: {},
      dialogVisible: false,
      isCouponGrantDisabled: false,
      listUserArr: [],
      couponInfo: {
        dialogVisible: false,
        couponUserIds: '',
        couponName: null,
        couponType: null,
        discountAmount: null,
        discountStart: null,
        businessType: null,
        startTime: null,
        endTime: null

      }
    };
  },
  created() {
    this.initParams = clone(this.listRequestData);
    this.initUserInfoList();
    this.initRolesAndUserStatus();
  },
  methods: {
    async initUserInfoList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getUserCouponList(this.listRequestData);
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询用户列表失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    initRolesAndUserStatus() {
      this.userRoleArr = [{ id: '', text: '全部' }].concat(USER_ROLE_GROUP.userRole);
      this.userStatusArr = [{ id: '', text: '全部' }].concat(USER_ROLE_GROUP.userStatus);
    },
    loginType(type) {
      return this.$options.filters['loginType'](type);
    },
    userStatus(status) {
      return this.$options.filters['userStatus'](status);
    },
    addTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    },
    sortChange(columnData) {
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initUserInfoList();
    },
    showUserInfo(row) {
      eventBus.$emit('userInfoDialog', row.userId);
    },
    // 分页
    paginationData(pageNum) {
      this.listRequestData.start = pageNum;
      this.initUserInfoList();
    },
    resetForm: function() {
      this.listRequestData = clone(this.initParams);
      this.initUserInfoList();
    },
    submitForm() {
      this.initUserInfoList();
    },
    // 改变选择用户数组
    listUserHandleSelectionChange: function(rows) {
      this.listUserArr = [];
      rows.forEach(element => {
        if (element.isCheck !== '1') {
          this.listUserArr.push(element.userId);
        }
      });
    },
    // 点击发放优惠券事件
    chooseUserClick: function() {
      if (this.listUserArr.length === 0) {
        this.$message.error('请选择用户');
        return false;
      }
      this.isCouponGrantDisabled = true;
      this.couponInfo.couponUserIds = this.listUserArr.join(',');
      this.dialogVisible = true;
      // this.$emit('onChooseSupplierClick', {
      //   arr: this.listSupplierArr,
      //   next: () => {
      //     this.isCouponGrantDisabled = false;
      //     this.$refs.listCouponUserRef.clearSelection();
      //   }
      // });
    },
    onCloseDialog: function() {
      this.isCouponGrantDisabled = false;
      this.$refs.listCouponUserRef.clearSelection();
    }
  }
};
</script>
<style lang="less" scoped>
#CouponGrantList {
  .button-group {
    margin-left: 771px;
    margin-bottom: 20px;
  }
  .form {
    max-width: 100%;
    margin-top: 30px;
  }
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
  }
  .button {
    height: 35px;
    width: 80px;
  }
  .a-font-red {
    color: #fb5b3b;
  }
}
</style>
